import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    getPreplotPageApi,
    getPreplotListDataApi,
    postPreplotDataApi,
    deletPreplotTableDataApi,
    getPreplotIdDataApi,
    putPreplotDataApi
} from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    dictData: null, // 树形多选框字典
    locationTreeCheckDictData: null, // 已选中树形多选框
    locationData: null, // 场所信息列表
    paginatedData: null, // 分页数据
    idData: null, // 单条回显数据
    pageNum: 1, // 初始分页数
}

/* 获取所有 Preplot 列表 */
export const getPreplotListDataAction = createAsyncThunk(
    'PreplotSlice/getPreplotListDataAction',
    async (projectId, thunkAPI) => {
        try {
            const { data } = await getPreplotListDataApi(projectId)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 查询分页数据 */
export const getPreplotPageAction = createAsyncThunk('PreplotSlice/getPreplotPageAction', async (params, thunkAPI) => {
    try {
        const { data } = await getPreplotPageApi(params)
        return data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 新增数据 */
export const postPreplotDataAction = createAsyncThunk(
    'PreplotSlice/postPreplotDataAction',
    async ({ params, file, modalAddNew }, thunkAPI) => {
        try {
            if (modalAddNew) {
                const data = await postPreplotDataApi(params, file)
                return data
            } else {
                const data = await putPreplotDataApi(params, file)
                return data
            }
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 删除 Preplot 表格单条数据 */
export const deletPreplotTableDataAction = createAsyncThunk(
    'PreplotSlice/deletPreplotTableDataAction',
    async (id, thunkAPI) => {
        try {
            const { data } = await deletPreplotTableDataApi(id)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 通过 id 获取项目 */
export const getPreplotIdDataAction = createAsyncThunk('PreplotSlice/getPreplotIdDataAction', async (id, thunkAPI) => {
    try {
        const { data } = await getPreplotIdDataApi(id)
        return data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

export const PreplotSlice = createSlice({
    name: 'PreplotSlice',
    initialState,
    reducers: {
        changepPageNum: (state, action) => {
            state.pageNum = action.payload
        },
    },
    extraReducers: {
        /* 获取所有文件 */
        [getPreplotListDataAction.fulfilled.type]: (state, action) => {
            state.locationData = action.payload
        },

        /* 分页数据 */
        [getPreplotPageAction.fulfilled.type]: (state, action) => {
            state.paginatedData = action.payload
        },

        /* 通过 ID 获取文件数据 */
        [getPreplotIdDataAction.fulfilled.type]: (state, action) => {
            state.idData = action.payload
        },
    },
})
